<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: shenlin
 * @LastEditTime: 2022-05-06 14:51:59
-->
<template>
  <div class="box">
    <div class="header">
      <div class="header-serach">
        <el-form :inline="true" :model="ruleform">
          <el-form-item label="">
            <el-input
              v-model="ruleform.entName"
              placeholder="搜索机构名称"
              @keyup.enter.native="getSearch"
              clearable
              @clear="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="ruleform.videoTime"
              type="datetimerange"
              @change="getPoss"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-form>

        <el-radio-group
          v-model="ruleform.proveStatus"
          size="small"
          @change="getPoss"
        >
          <el-radio-button
            :label="item.value"
            v-for="item in statusList"
            :key="item.label"
            >{{ item.label + (item.num != null?item.num:'') }}</el-radio-button
          >
        </el-radio-group>
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column
        prop="entName"
        label="机构名称"
        width="300"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="联系人"
        prop="contact"
        width="250"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="contactTel"
        label="联系电话"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="serviceNameList"
        label="服务类型"
        align="center"
        width="190"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{
            scope.row.serviceNameList ? scope.row.serviceNameList.join(',') : ''
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="申请时间"
        align="center"
      ></el-table-column>
      <el-table-column prop="proveStatus" align="center" label="审核状态">
        <template slot-scope="scope">
          <div>
            <span
              :class="{
                greenColor: scope.row.proveStatus == 3,
                redColor:
                  scope.row.proveStatus == 2 || scope.row.proveStatus == 4,
                greyColor: scope.row.proveStatus == 1
              }"
              style="
                width: 8px;
                height: 8px;
                display: inline-block;
                border-radius: 50%;
              "
            ></span>
            {{ proveStatusList[scope.row.proveStatus] }}
          </div>
        </template></el-table-column
      >
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <span
            style="margin-right: 10px; color: #1890ff; cursor: pointer"
            @click="
              edit(
                scope.row.creditCode,
                scope.row.entName,
                scope.row.proveStatus,
                2
              )
            "
            >{{ scope.row.proveStatus == 1 ? '审核' : '查看' }}</span
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { listCheckByPage } from '@api/yardIntermediary/institutionalAudit'
export default {
  data() {
    return {
      ttt: true,
      areaList: [],
      ruleform: {
        organizationType: '2',
        entName: '', // 机构名称
        proveStatus: '', // 审核状态
        videoTime: '' // 选择时间
      },
      proveStatusList: {
        0: '未认证',
        1: '待审核',
        2: '申请驳回',
        3: '审核通过',
        4: '退回'
      },
      statusList: [
        { value: '', label: '全部', num: null },
        { value: 1, label: '待审核', num: null },
        { value: 2, label: '申请驳回', num: null },
        { value: 3, label: '审核通过', num: null },
        { value: 4, label: '退回', num: null }
      ], // 所有类别数据
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0,
      roleText: ''
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.listLiveData()
  },
  methods: {
    // 视频名称
    getSearch() {
      this.currentPage = 1
      this.listLiveData()
    },
    // 所有类别
    getPoss() {
      this.currentPage = 1
      this.listLiveData()
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.listLiveData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listLiveData()
    },
    edit(creditCode, entName, proveStatus, organizationType) {
      this.$router.push({
        name: 'auditDetail',
        query: {
          creditCode: creditCode,
          entName: entName,
          proveStatus: proveStatus,
          organizationType: organizationType
        }
      })
    },
    // 列表
    listLiveData() {
      console.log(this.ruleform.organizationType)
      let par = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        entName: this.ruleform.entName,
        organizationType: this.ruleform.organizationType,
        proveStatus: this.ruleform.proveStatus,
        startTime: this.ruleform.videoTime ? this.ruleform.videoTime[0] : '',
        endTime: this.ruleform.videoTime ? this.ruleform.videoTime[1] : ''
      }
      listCheckByPage(par).then((res) => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData = list.pageInfo.list || []
          this.totalRecord = list.pageInfo.total || 0
          this.statusList[1].num = list.waitAuditNum
          this.statusList[2].num = list.rejectNum
          this.statusList[3].num = list.passNum
          this.statusList[4].num = list.backNum
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.greenColor {
  background: rgb(73, 194, 105);
}
.redColor {
  background: rgb(251, 76, 76);
}
.greyColor {
  background: rgba(0, 119, 255, 0.9);
}
.header {
  display: flex;
  margin-bottom: 20px;
  .header-serach {
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
}
.box {
  padding: 24px 0px 0px;
  background: #fff;
}
.actcolor {
  color: #1890ff;
}
.nocolor {
  color: rgba(0, 0, 0, 0.3);
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
.sharing-code {
  display: flex;
  span {
    line-height: 34px;
  }
  /deep/.el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  /deep/.el-button--medium {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.exhibition {
  // margin-top: 20px;
  margin-left: -25px;
  display: flex;
  #qrcode {
    width: 125px;
    height: 150px;
    margin: 20px auto;
  }
  .refreshs {
    margin: 20px auto;
    span {
      margin-left: 22px;
    }
    .refresh {
      margin-left: 50px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
.el-popover {
  min-width: 100px !important;
}
</style>
